import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-all-in-one-pcs-for-coding-stem-skill-development-labs',
  templateUrl: './all-in-one-pcs-for-coding-stem-skill-development-labs.component.html',
  styleUrls: ['./all-in-one-pcs-for-coding-stem-skill-development-labs.component.scss']
})
export class AllInOnePcsForCodingStemSkillDevelopmentLabsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Best All-in-One PCs for Coding, STEM & Skill Development Labs VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Discover how VIRSA All-in-One PCs help schools, colleges, STEM labs, coding classrooms, and skill development centers create modern, high-performance digital learning environments.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'All in One PCs for schools, coding lab computers, STEM lab computers, all in one PC for education, skill development lab setup, VIRSA all in one PCs, computer lab solutions India, smart lab solutions for schools'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
